import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { HelpButton } from '@bingads-webui-react/help-popup';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  Card,
  CardHeader,
  makeStyles,
  Subtitle2,
  Switch,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  cardHeader: {
    display: 'flex',
    '& input': {
      height: '100%',
      width: '100%',
    }
  },
});

export const MeasurementTypeCard = ({
  children,
  description,
  helpId,
  isAllowed,
  isEnabled,
  onToggle,
  title,
}) => {
  const styles = useStyles();
  const i18n = useContext(I18nContext);
  const learnMore = i18n.getString(_TL_('Click to learn more about'));

  const className = title.toLowerCase().replace(/ /g, '-');

  return (
    <Card className={`${className}-card`}>
      <CardHeader
        header={
          <div className={styles.cardHeader}>
            <Switch
              checked={isEnabled}
              disabled={!isAllowed}
              label={<Subtitle2>{title}</Subtitle2>}
              onChange={onToggle}
            />
            <HelpButton
              aria-label={`${learnMore} ${title}`}
              topic={helpId}
            />
          </div>
        }
      />
      {description}
      {children}
    </Card>
  );
};

MeasurementTypeCard.propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
  ]),
  helpId: PropTypes.string.isRequired,
  isAllowed: PropTypes.bool.isRequired,
  isEnabled: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

MeasurementTypeCard.defaultProps = {
  description: null,
  isEnabled: true,
};
